howspace.components.progress = (() => {
    'use strict';

    const update = (progress, percentage, callback) => {
        if (progress.length === 0 || !progress.hasClass('howspace-progress-initialized')) {
            return;
        }

        if (progress.is('.howspace-progress')) {
            const progressBar = progress.find('.howspace-progress-bar');
            progressBar.find('.howspace-progress-text').removeClass('d-none');
            progressBar.attr('aria-valuenow', percentage);
            progressBar.width(percentage + '%');
            progressBar.find('.howspace-progress-percentage').removeClass('d-none');
            progressBar.find('.howspace-progress-percentage').html(percentage + '%');
        } else if (progress.is('.howspace-progress-circle')) {
            const progressCircle = progress.find('.progress');
            const strokeDashArray = parseInt(progressCircle.attr('stroke-dasharray').replace('px', ''));
            const strokeDashOffset = strokeDashArray * ((100 - percentage) / 100);

            progressCircle.css('stroke-dashoffset', strokeDashOffset);
        }

        howspace.dispatchEvent(progress, howspace.components.progress.PROGRESS_UPDATE, {
            percentage: percentage
        });

        if (typeof callback === 'function') {
            callback();
        }
    }

    const reset = (progress, callback) => {
        if (progress.length === 0 || !progress.hasClass('howspace-progress-initialized')) {
            return;
        }

        const progressBar = progress.find('.howspace-progress-bar');
        progressBar.find('.howspace-progress-text').addClass('d-none');
        progressBar.attr('aria-valuenow', 0);
        progressBar.width(0);
        progressBar.find('.howspace-progress-percentage').addClass('d-none');
        progressBar.find('.howspace-progress-percentage').html('');

        howspace.dispatchEvent(progress, howspace.components.progress.PROGRESS_UPDATE, {
            percentage: 0
        });

        if (typeof callback === 'function') {
            callback();
        }
    }

    return {
        PROGRESS_UPDATE: 'howspace-progress-update',
        init: (elem) => {
            elem.findIncludingSelf('.howspace-progress:not(.howspace-progress-initialized)').each(function () {
                const progress = $(this);
                progress.addClass('howspace-progress-initialized');
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-progress.howspace-progress-initialized').each(function () {
                const progress = $(this);
                progress.removeClass('howspace-progress-initialized');
                reset(progress);
            });
        },
        update: update,
        reset: reset
    };

})();
